import {
  SMART_DROPDOWN_FILE_UPLOAD,
  SMART_DROPDOWN_FILE_UPLOAD_SUCCESS,
  SMART_DROPDOWN_FILE_UPLOAD_ERROR,
} from "./actionTypes"

const initialState = {
  loadingUpload: false,
  errorUpload: "",
}

const SmartDropzone = (state = initialState, action) => {
  switch (action.type) {
    case SMART_DROPDOWN_FILE_UPLOAD:
      state = {
        ...state,
        loadingUpload: true,
        errorUpload: "",
      }
      break
    case SMART_DROPDOWN_FILE_UPLOAD_SUCCESS:
      state = {
        ...state,
        loadingUpload: false,
        errorUpload: "",
      }
      break
    case SMART_DROPDOWN_FILE_UPLOAD_ERROR:
      state = {
        ...state,
        loadingUpload: false,
        errorUpload: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default SmartDropzone
